module.exports = __webpack_public_path__ + "static/img/sort.480dac3a.svg";